<template>
    <div class="card bio-card mb-4">
        <div class="card-image" v-if="hasPhoto">
            <div class="image">
                <img :src="card.profilePicture" />
            </div>
        </div>
        <div class="card-content">
            <p
                class="title is-4 is-spaced"
                v-if="hasName"
                v-text="card.name"
            ></p>
            <p class="subtitle is-6 is-spaced">
                <a
                    target="_blank"
                    class="social-link"
                    :href="card.twitter"
                    v-if="hasTwitter"
                    :title="card.twitter"
                    :alt="card.twitter"
                    ><i class="fab fa-twitter text-blue-400"></i
                ></a>
                <a
                    target="_blank"
                    class="social-link"
                    :href="card.facebook"
                    v-if="hasFacebook"
                    ><i class="fab fa-facebook text-blue-700"></i
                ></a>
                <a
                    target="_blank"
                    class="social-link"
                    :href="card.instagram"
                    v-if="hasInstagram"
                    ><i class="fab fa-instagram text-yellow-800"></i
                ></a>
                <a
                    target="_blank"
                    class="social-link"
                    :href="card.linkedin"
                    v-if="hasLinkedIn"
                    ><i class="fab fa-linkedin-in text-blue-500"></i
                ></a>
            </p>
            <p
                class="subtitle is-6 is-spaced"
                v-if="hasHello"
                v-text="card.hello"
            ></p>
        </div>
    </div>
</template>
<script>
export default {
    props: ["card"],
    methods: {},
    computed: {
        hasPhoto: function() {
            return typeof this.card.profilePicture !== "undefined" &&
                this.card.profilePicture !== null &&
                this.card.profilePicture.length
                ? true
                : false;
        },
        hasName: function() {
            return typeof this.card.name !== "undefined" &&
                this.card.name !== null &&
                this.card.name.length
                ? true
                : false;
        },
        hasTwitter: function() {
            return typeof this.card.twitter !== "undefined" &&
                this.card.twitter !== null &&
                this.card.twitter.length
                ? true
                : false;
        },
        hasFacebook: function() {
            return typeof this.card.facebook !== "undefined" &&
                this.card.facebook !== null &&
                this.card.facebook.length
                ? true
                : false;
        },
        hasInstagram: function() {
            return typeof this.card.instagram !== "undefined" &&
                this.card.instagram !== null &&
                this.card.instagram.length
                ? true
                : false;
        },
        hasLinkedIn: function() {
            return typeof this.card.linkedin !== "undefined" &&
                this.card.linkedin !== null &&
                this.card.linkedin.length
                ? true
                : false;
        },
        hasHello: function() {
            return typeof this.card.hello !== "undefined" &&
                this.card.hello !== null &&
                this.card.hello.length
                ? true
                : false;
        }
    }
};
</script>
